export default {
  $notificationMenuNav: null,
  $notificationMenuNavMobile: null,
  $notificationSection: null,
  $notificationBackground: null,
  $notificationClose: null,
  $currentActiveItem: null,
  $currentActiveItemMobile: null,
  isMobile: false,
  init () {
    this.$notificationMenuNav = $('.nav-link-item.notification')
    this.$notificationMenuNavMobile = $('.nav-item.notification .x-button-link')
    this.$notificationSection = $('.section-notifications')
    this.$notificationSectionMobile = $('.mobile .section-notifications')
    this.$notificationClose = $('.section-notifications .modal-close')
    this.$notificationBackground = $('.section-notifications-background')
    this.$currentActiveItem = $('.nav-link-item.active')
    this.$currentActiveItemMobile = $('.nav-item.swiper-slide.active')
    console.log('init notifications')
    this.handleClicks()
  },

  handleClicks () {
    console.log('handleclicks', this.$notificationMenuNav)
    const unreadNotificatiton = this.$notificationSection.data('unread')
    if (typeof unreadNotificatiton !== 'undefined' && parseInt(unreadNotificatiton, 10) > 0) {
      this.$notificationMenuNav.append('<span class="counter-unread">' + unreadNotificatiton + '</span>')
      this.$notificationMenuNavMobile.append('<span class="counter-unread">' + unreadNotificatiton + '</span>')
    }
    this.$notificationMenuNav.click(() => {
      this.isMobile = false
      this.openNotifications()
    })

    this.$notificationMenuNavMobile.click(() => {
      this.isMobile = true
      this.openNotifications()
    })

    this.$notificationBackground.click(() => {
      this.closeNotifications()
    })

    this.$notificationClose.click(() => {
      this.closeNotifications()
    })
  },

  openNotifications () {
    this.$notificationSection.addClass('show')
    this.$notificationSectionMobile.addClass('show')
    this.$currentActiveItem.removeClass('active')
    this.$currentActiveItemMobile.removeClass('active')
    $('body').addClass('open-notifications')
    if (!this.isMobile) this.$notificationBackground.show()
  },

  closeNotifications () {
    this.$notificationSection.removeClass('show')
    this.$notificationSectionMobile.removeClass('show')
    this.$currentActiveItem.addClass('active')
    this.$currentActiveItemMobile.addClass('active')
    $('body').removeClass('open-notifications')
    this.$notificationBackground.hide()
  }
}
